export default class LoggedOnStatusService {
  public static readonly LOGGED_IN = 'Logged In';
  public static readonly LOGGED_OUT = 'Logged Out';

  public static isLoggedIn(loginStatus: string): boolean {
    return loginStatus === LoggedOnStatusService.LOGGED_IN;
  }

  public static getLoginStatus(isLoggedIn: boolean): string {
    return isLoggedIn ? LoggedOnStatusService.LOGGED_IN : LoggedOnStatusService.LOGGED_OUT;
  }
}
